import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as userPreference from './user-preference.reducers';

export const userPreferenceKey = 'userPreferences';


export interface UserPreferenceState {
  [userPreference.userPreferencesKey]: userPreference.State;
}

export function reducers(state: UserPreferenceState | undefined, action: Action) {
  return combineReducers({
    [userPreference.userPreferencesKey]: userPreference.userPreferenceReducer
  })(state, action);
}

export const selectPreferences = createFeatureSelector<UserPreferenceState>(
  userPreferenceKey
);

export const selectPreferencesLoaded = createSelector(
  selectPreferences,
  (state) => {
    return state['tablePreferences'].preferencesLoaded;
  }
);

export const selectTabPreference = createSelector(
  selectPreferences,
  (state) => {
    const preferences = state['tablePreferences'].tabs
    const ids = Object.keys(preferences);
    const preferenceArray = ids
      .map((id) => preferences[`${id}`]);
    return preferenceArray
  }
);


export const selectInitTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return  value.tabName === 'all' &&
       value.tableName === 'init'
    })
  }
);

export const selectInitTabForMasterAccount = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return  value.tabName === 'all' &&
       value.tableName === 'init master transactions view'
    })
  }
);
export const selectAllTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'all' &&
      value.tableName === 'standing authorizations'
    })
  }
);

export const selectMsvAllTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'all' &&
      value.tableName === 'master standing authorizations'
    })
  }
)

export const selectInternalTransferTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'internal transfers' &&
      value.tableName === 'standing authorizations'
    })
  }
);

export const selectAchTransferTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'ach transfers' &&
      value.tableName === 'standing authorizations'
    })
  }
);

export const selectWiresTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'wires' &&
      value.tableName === 'standing authorizations'
    })
  }
);

export const selectChecksTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'checks' &&
      value.tableName === 'standing authorizations'
    })
  }
);

export const selectAllTransactionsTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'all' &&
      value.tableName === 'transactions'
    })
  }
);

export const selectRecentTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'recent' &&
      value.tableName === 'transactions'
    })
  }
);

export const selectRecurringTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'recurring' &&
      value.tableName === 'transactions'
    })
  }
);

export const selectRecurringTable = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tableName === 'recurring'
    })
  }
);

export const selectUpcomingTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'upcoming' &&
      value.tableName === 'transactions'
    })
  }
);

export const selectTemplatesTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'saved wire templates' &&
      value.tableName === 'transactions'
    })
  }
);

export const selectMasterTransactionStatusTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'transaction status' && value.tableName === 'master transactions'
    })
  }
);

export const selectMasterRecurringTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'recurring' && value.tableName === 'master transactions'
    })
  }
);

export const selectMasterActivityReportTab = createSelector(
  selectTabPreference,
  (state) => {
    return state.find(value => {
      return value.tabName === 'activity report' && value.tableName === 'master transactions'
    })
  }
);
